/* The corporate ladder (09-26, theme setting "The corporate ladder"). The title lives in Liquid
   (snippets/career-ladder.liquid); this only keeps the header's copy of it current when the cart re-renders in place
   (portal.js fires twd:cart-rendered) and posts corp.communications' notice, the zine's all-staff format, as an Outlook
   desktop alert: once per level per session, only upward, never over the checkout (bottom left on desktops, top on
   phones), gone after eight seconds or on its X. A click on it shows the ladder. */
(function () {
  'use strict';
  var box = document.querySelector('[data-career-alert]');
  var KEY = 'twd-career-max';
  var timer = null;

  function data() {
    var root = document.querySelector('[data-cart-root]');
    return root ? root.querySelector('[data-career]') : null;
  }
  function highest() {
    try { return parseInt(window.sessionStorage.getItem(KEY), 10) || 0; } catch (e) { return 99; }
  }
  function remember(level) {
    try { window.sessionStorage.setItem(KEY, String(level)); } catch (e) { /* private mode: no notice, nothing else */ }
  }
  function hide() {
    if (!box || box.hidden) { return; }
    window.clearTimeout(timer);
    box.classList.remove('is-in');
    window.setTimeout(function () { if (!box.classList.contains('is-in')) { box.hidden = true; } }, 220);
  }
  function show(d, wait) {
    box.querySelector('[data-alert-subject]').textContent = d.getAttribute('data-subject');
    box.querySelector('[data-alert-body]').textContent = d.getAttribute('data-body');
    box.hidden = false;
    window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { box.classList.add('is-in'); }); });
    window.clearTimeout(timer);
    timer = window.setTimeout(hide, wait);
  }
  function sync() {
    var d = data();
    if (!d) { return; }
    var titles = document.querySelectorAll('[data-career-title]');
    for (var i = 0; i < titles.length; i++) { titles[i].textContent = d.getAttribute('data-title'); }
    var level = parseInt(d.getAttribute('data-level'), 10) || 0;
    if (level > highest()) {
      remember(level);
      if (box && level > 0) { show(d, 8000); }
    }
  }

  if (box) {
    box.addEventListener('click', function (event) {
      if (event.target.closest('[data-alert-close]')) { hide(); return; }
      var pane = document.querySelector('.ladder');
      hide();
      if (pane) { pane.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    });
    box.addEventListener('mouseenter', function () { window.clearTimeout(timer); });
    box.addEventListener('mouseleave', function () { if (!box.hidden) { timer = window.setTimeout(hide, 3000); } });
    document.addEventListener('keydown', function (event) {
      if ((event.key === 'Escape' || event.key === 'Esc') && !box.hidden) { hide(); }
    });
  }
  document.addEventListener('twd:cart-rendered', sync);
  sync();
})();
